/**
 * Redux store
 * @author luoying
 * @since 17/10/17
 */

import * as redux from 'redux';
import * as reducers from 'reducers';
import thunk from 'redux-thunk';
let store;

// 开启chrome redux-dev-tool调试
const devTool = window.__REDUX_DEVTOOLS_EXTENSION__
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : f => f;

const enhancer = redux.compose(
  redux.applyMiddleware(thunk),
  devTool
);
export function createStore(state = {}) {
  const _reducers = redux.combineReducers({
    ...reducers,
  });
  store = redux.createStore(_reducers, state, enhancer);
  return store;
}

createStore(
  window.INIT_STATE &&
    JSON.parse(JSON.stringify(window.INIT_STATE).replace(/&lt;/g, '<'))
);

export default store;
